import {html} from "@isceco/widget-library2/external/lit";

export default function createProjectRaumfahrttechnologien(formComponent) {
  return html`
    <isceco-card text="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project1.title')}"
                 class="form-card">
      <isceco-text-input
        label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project1.subtitle')}"
        name="project.title"
        required
        .readonly="${formComponent.preview}">
      </isceco-text-input>
      <isceco-file-input
        label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project1.upload.overview')}"
        name="project.attachmentOverview"
        required
        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        maxfiles="1"
        maxsize="${formComponent.fileMaxSize}"
        .fileInputService="${formComponent.fileInputService}"
        .disabled="${formComponent.preview}"
      ></isceco-file-input>
      <isceco-textarea
        label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project1.description')}"
        name="project.description"
        rows="4"
        .readonly="${formComponent.preview}"
        required
      ></isceco-textarea>
      <isceco-file-input
        label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project1.upload.attachments')}"
        name="project.attachments"
        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        maxfiles="25"
        multiple
        maxsize="${formComponent.fileMaxSize}"
        .fileInputService="${formComponent.fileInputService}"
        .disabled="${formComponent.preview}"
      ></isceco-file-input>
      <isceco-textarea label="${formComponent.i18n.translate('form.request.projektfinanzierungsgesuch.project1.note')}"
                       name="project.note"
                       rows="4"
                       .readonly="${formComponent.preview}"
      ></isceco-textarea>
    </isceco-card>`
}
